import { useCallback, useState } from 'react'
import { hasLocalStorage } from 'utils'
import MemoryStorage from 'memorystorage'

// Use memory storage if local storage is disabled
const memory = new MemoryStorage('profile-onboarding')
const localStoragePolyfill = hasLocalStorage() ? window.localStorage : memory

export const useLocalStorage = (
  key: string
): [string, (val: string) => void] => {
  const init = localStoragePolyfill.getItem(key) || undefined
  const [state, setReactState] = useState<string>(init)
  const setState = useCallback(
    (newState) => {
      if (newState === undefined || newState === null) {
        localStoragePolyfill.removeItem(key)
      } else {
        localStoragePolyfill.setItem(key, newState)
      }
      setReactState(newState)
    },
    [setReactState, key]
  )

  return [state, setState]
}
